import * as React from "react";

import Box from "@mui/material/Box";

import { useDispatch, useSelector } from "react-redux";
import { setLogoutUser } from "../redux/slices/userSlice";
import { setLogout } from "../redux/slices/authSlice";
import axios from "axios";
import { useState, useEffect } from "react";
import "./NavigationBar.css";

import image1 from "../logos/homescreen.png";
import image2 from "../logos/regretscreen.png";

import { setLogoutCurrentEmms } from "../redux/slices/currentEmmsSlice";
import { setLogoutLocation } from "../redux/slices/locationSlice";
import { setLogoutCustomisation } from "../redux/slices/customisationSlice";
import { setLogoutMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { setLogoutScreenuser } from "../redux/slices/screenusersSlice";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";

import PermanentDrawerLeft from "./PermanentDrawer";
import { CssBaseline } from "@mui/material";
import TruInk from "./TruInk/Screens/TruInk";

export default function NavigationBar() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [activeComponent, setActiveComponent] = useState(null);
  const email = user.user.email;
  const username = email?.substring(0, email.indexOf("@"));

  const [license, setLicense] = useState(false);
  const headers = useSelector((state) => state?.header.headers);

  useEffect(() => {
    const api = localStorage.getItem("api");

    axios
      .get(api + `/list/license`, { headers })
      .then((response) => {
        if (response?.data?.length > 0) setLicense(true);
        else {
          setLicense(false);
          setActiveComponent(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching licenses:", error);
   
        if (error?.message == "Network Error") {
          dispatch(setLogoutUser());
        } else if (error?.response?.data == "jwt expired") {
          dispatch(setLogoutUser());
        }
     
        setLicense(false);

      });
  }, []);

  const handlesignout = () => {
    dispatch(setLogoutUser());
    dispatch(setLogout());
    dispatch(setLogoutCurrentEmms());
    dispatch(setLogoutLocation());
    dispatch(setLogoutCustomisation());
    dispatch(setLogoutMeetingSpaces());
    dispatch(setLogoutScreenuser());
    dispatch(setEmmsHeaders());
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    <>

      <Box sx={{ flexGrow: 1 }}>
        <PermanentDrawerLeft
          activeComponent={activeComponent}
          setActiveComponent={setActiveComponent}
          license={license}
        />

        <Box>{activeComponent}</Box>
      </Box >
      {activeComponent === null ? (
        <div className="homeScreenImgContainer">
          <header>
            <figure className="emms-image-figure">
              {license ? (
                <img className="img emm-image" src={image1} alt="Logo 1" />
              ) : (
                <img className="img emm-image" src={image2} alt="Logo 2" />
              )}
            </figure>
          </header>
        </div>
      ) : null
      }
    </>
  );
}
